import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IOrderSchemaPartial } from '../../type/order';

export interface IProposeQuotationOrderAskForQuoteMutationFields {
  _id: string;
  companyId: string;
}


export interface IProposeQuotationOrderAskForQuoteMutationResponseFields {
  createdQuotation: IOrderSchemaPartial;

}


export function proposeQuotationOrderAskForQuoteMutation(fragment: string): DocumentNode {
  return gql`
        mutation proposeQuotationOrderAskForQuote (
        $_id: String!,
$companyId: String!
        ) {
        proposeQuotationOrderAskForQuote (
        _id: $_id,
companyId: $companyId
        ) {
        ...fragment
        }
        }
        fragment fragment on ProposeQuotationOrderAskForQuoteMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useProposeQuotationOrderAskForQuoteMutation<TData extends Partial<IProposeQuotationOrderAskForQuoteMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ proposeQuotationOrderAskForQuote: TData },
        IProposeQuotationOrderAskForQuoteMutationFields>,
) {
  return useMutation<{ proposeQuotationOrderAskForQuote: TData },
      IProposeQuotationOrderAskForQuoteMutationFields>(
        proposeQuotationOrderAskForQuoteMutation(fragment), options,
      );
}
